module.exports = __webpack_public_path__ + "img/cta-sport-mob-nl.94d9f067.png";